import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { SectionTitle } from 'components';
import SeatkImg from 'assets/cards/steak.svg';
import chickenImg from 'assets/cards/chicken.svg';
import fishkImg from 'assets/cards/fish.svg';
import saladImg from 'assets/cards/salad.svg';
import pudimImg from 'assets/cards/pudim.svg';
import drinksImg from 'assets/cards/drinks.svg';
import { analytics } from 'config/firebase';
import { TextoCard } from './styles';

const SectionIcons = () => {
  const onClick = event => {
    analytics.logEvent('home_cardapio_btn_click', {
      section: event.currentTarget.name,
    });
  };
  return (
    <Container className="py-5">
      <SectionTitle title="NOSSO CARDÁPIO" href="/pedido" />
      <Row className="my-4">
        <Col xs={6} lg={4} className="text-center my-4">
          <Link
            to={{ pathname: '/pedido', hash: '#REFEIÇÕES/CARNE' }}
            onClick={onClick}
            name="REFEIÇÕES/CARNE"
          >
            <Image src={SeatkImg} height={120} />
            <TextoCard>CARNES</TextoCard>
          </Link>
        </Col>
        <Col xs={6} lg={4} className="text-center my-4">
          <Link
            to={{ pathname: '/pedido', hash: '#REFEIÇÕES/FRANGO' }}
            onClick={onClick}
            name="REFEIÇÕES/FRANGO"
          >
            <Image src={chickenImg} height={120} />
            <TextoCard>FRANGOS</TextoCard>
          </Link>
        </Col>
        <Col xs={6} lg={4} className="text-center my-4">
          <Link
            to={{ pathname: '/pedido', hash: '#REFEIÇÕES/PEIXE' }}
            onClick={onClick}
            name="REFEIÇÕES/PEIXE"
          >
            <Image src={fishkImg} height={120} />
            <TextoCard>PEIXES</TextoCard>
          </Link>
        </Col>
        <Col xs={6} lg={4} className="text-center my-4">
          <Link to={{ pathname: '/pedido', hash: '#SALADAS' }} onClick={onClick} name="SALADAS">
            <Image src={saladImg} height={120} />
            <TextoCard>SALADAS</TextoCard>
          </Link>
        </Col>
        <Col xs={6} lg={4} className="text-center my-4">
          <Link
            to={{ pathname: '/pedido', hash: '#SOBREMESAS' }}
            onClick={onClick}
            name="SOBREMESAS"
          >
            <Image src={pudimImg} height={120} />
            <TextoCard>SOBREMESAS</TextoCard>
          </Link>
        </Col>
        <Col xs={6} lg={4} className="text-center my-4">
          <Link to={{ pathname: '/pedido', hash: '#DRINKS' }} name="DRINKS" onClick={onClick}>
            <Image src={drinksImg} height={120} />
            <TextoCard>DRINKS</TextoCard>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default SectionIcons;
